"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeOnChange = exports.TYPES = void 0;

var date_fns_1 = require("date-fns");

exports.TYPES = {
  day: {
    length: 2
  },
  month: {
    length: 2
  },
  year: {
    length: 4
  },
  hour: {
    length: 2
  },
  minute: {
    length: 2
  }
};

var makeOnChange = function makeOnChange(_a) {
  var _b = _a.date,
      date = _b === void 0 ? new Date() : _b,
      onNext = _a.onNext,
      onSet = _a.onSet,
      type = _a.type;
  return function (e) {
    var _a, _b, _c, _d;

    var value = Number(e.target.value);
    var length = exports.TYPES[type].length;
    var lastDayOfMonth = (0, date_fns_1.getDate)((0, date_fns_1.lastDayOfMonth)(date));
    var atMaxLength = ((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) >= length;
    var isInvalid = ((_d = (_c = e.target) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.length) <= 0 || Number.isNaN(value);

    switch (type) {
      case 'day':
        {
          if (isInvalid) {
            onSet('');
            break;
          } // Set day to value between 1 and the last day of that month.


          if (value > lastDayOfMonth) {
            onSet(String(lastDayOfMonth));
          } else {
            onSet(String(value));
          }

          if (atMaxLength) {
            return onNext();
          }

          break;
        }

      case 'month':
        {
          if (isInvalid) {
            onSet('');
            break;
          } // Set month to value between 1 and 12.


          if (value > 12) {
            onSet('12');
          } else {
            onSet(String(value));
          }

          if (atMaxLength) {
            return onNext();
          }

          break;
        }

      case 'year':
        {
          if (isInvalid) {
            onSet('');
            break;
          }

          onSet(String(value));

          if (atMaxLength) {
            return onNext();
          }

          break;
        }

      case 'hour':
        {
          if (isInvalid) {
            onSet('');
            break;
          }

          if (value > 12) {
            onSet(String(value - 12));
          } else {
            onSet(String(value));
          }

          if (atMaxLength) {
            return onNext();
          }

          break;
        }

      case 'minute':
        {
          if (isInvalid) {
            onSet('');
            break;
          }

          if (value > 59) {
            onSet(String(value - 60));
          } else {
            onSet(String(value));
          }

          if (atMaxLength) {
            return onNext();
          }

          break;
        }
    }
  };
};

exports.makeOnChange = makeOnChange;